import toast from "react-hot-toast";
import useSalutationPreferences from "../hooks/useSalutationPreferences";
import { IconButton } from "../../../components";
import { BasicToast } from "../../../components/toasts";
import { openDeleteSalutationModal } from "./DeleteSalutationModal";

const DeleteSalutationButton = ({ salutation }) => {
    const { salutationId, isDefault, isPrimary } = salutation;
    const { data, deleteSalutation } = useSalutationPreferences();

    const handleOnClick = (e) => {
        openDeleteSalutationModal(isDefault, data.filter(el => el.salutationId !== salutationId)).then(
            (newSalutation) => {
                handleOnDelete({ newDefaultSalutation: newSalutation });
            },
            () => {}
        );
    };

    const handleOnDelete = ({ newDefaultSalutation }) => {
        deleteSalutation(salutationId, newDefaultSalutation).then(
            _ => {
                toast.custom((t) => <BasicToast 
                    control={t} 
                    date={new Date()} 
                    icon="fa-solid fa-user-minus" 
                    title="Salutation Deleted" 
                    message={`Salutation preference was deleted.`}
                />, { duration: 8000 });
            },
            e => toast.error(e?.data?.message)
        )
    };

    return (
        <IconButton icon="fa-trash-can" variant="danger" disabled={isPrimary} onClick={handleOnClick} />
    );
};

export default DeleteSalutationButton;